import { Cart } from 'Types'

/**
 * Check if fbq function exist
 * @returns {boolean}
 */
const isFbExist = (): boolean => {
  if (!window.fbq) {
    console.log('%c Did you inject FB Pixel code? ', 'padding: 3px 10px; background-color: #3b5998; color: #fff;')

    return false
  }

  return true
}

/**
 * Send fbq InitiateCheckout event
 * @param {object} cart current cart
 */
export const sendFbPurchaseEvent = (cart: Cart): void => {
  if (!isFbExist()) return

  window.fbq('track', 'Purchase', {
    value: cart.totalPrice,
    currency: window?.VARIABLES?.shopCurrency || 'CAD',
    content_type: 'product',
    content_ids: cart.cartItems.map(({ id }) => id),
    num_items: cart.totalItems,
  })
}
